export default {"src":"/_next/static/media/footer_bump.14fc5948.svg","height":38,"width":142,"blurWidth":0,"blurHeight":0};